const possibleMinor = (option) => {
  return option ? 'Sim' : 'Não'
}

export default possibleMinor
